import React from "react";
import config from "../../../etc/config";



const withImageLoader = Component => {
    class HOC extends React.Component {
        // eslint-disable-next-line no-useless-constructor
        constructor(props) {
            super(props);
            this.state = {

            }
        }

        componentDidMount() {

        }

        load = (event) => {
            const formData = new FormData();
            const file = event.target.files[0];
            formData.append("photo", file, file.name);



            fetch(`${config.API_PREFIX}${this.props.resource}`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${this.props.token}`
                },
                body: formData
            })
                .then(res => res.json())
                .then(res => {
                    console.log(res);
                    if (res.status === 0) {
                        this.props.completion(res);
                    } else {
                        alert(res.message)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        };



        render() {
            return <Component imageLoaderDelegate={this} {...this.props} />
        }
    }

    HOC.displayName = `withImageLoader(${Component.displayName || Component.name || "Component"})`;
    return HOC
};


export default withImageLoader;